import {LitElement, html, css} from 'lit'
import { customElement, property, state } from 'lit/decorators.js';
import { SldsBaseElement } from '../components/slds-base-element.js';

@customElement("slds-combobox")
export class SldsCombobox extends SldsBaseElement {
  @property({type: String}) label;
  @property({type: String}) placeholder;
  @property({type: Array}) options = [];
  @state() isOpen = false;
  @property({type: Object}) selected = null;

  constructor() {
    super();
    document.addEventListener('click', (function(e) {
      if (this.isOpen) {
        const path = e.composedPath();
        let insideMenuClick = false;
        if(!(path === undefined || path.length == 0)) {
         insideMenuClick = path.find((el) => { return el == this; });
        }
        if(insideMenuClick) {
          //inside element
        } else {
          //outside element
          this.isOpen = false;
          const event = new CustomEvent('blur', { open: this.isOpen, bubbles: true });
          this.dispatchEvent(event);
        }
      }
    }).bind(this), false);

    document.addEventListener('keydown', (function(e) {
      if (this.isOpen && e.key.length === 1 && /^[a-zA-Z]$/.test(e.key)) {
        const char = e.key.toLowerCase();
        const optionIndex = this.options.findIndex(opt => opt.id.startsWith(char));
        if (optionIndex !== -1) {
          const optionElement = this.shadowRoot.querySelectorAll('ul.slds-listbox>li')[optionIndex];
          if (optionElement) {
            optionElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            const divElement = optionElement.querySelector('div.slds-listbox__option');
            if (divElement) {
              divElement.focus();
            }
          }
        }
      }
    }).bind(this));
  }

  static styles = [
    super.styles,
    css`
    :host {
      --slds-c-input-color-background: var(--background-color);
      --slds-c-input-color-border: var(--border-color);
    }
    .slds-form-element__label {
      color: var(--text-color);
    }
    .slds-dropdown {
      background: var(--background-color, #fff);
      color: var(--text-color, #181818);
      border: 1px solid var(--border-color, #e5e5e5);
    }
    .slds-dropdown__item>a {
      color: var(--text-color, #181818);
    }
    .slds-dropdown__item>a:focus, .slds-dropdown__item>a:hover {
      background-color: var(--table-hover, #f3f3f3);
    }
    .slds-input_faux:not(.slds-combobox__input-value) {
      color: var(--text-color, #181818);
    }
    .slds-listbox--vertical .slds-listbox__option.slds-has-focus, .slds-listbox--vertical .slds-listbox__option:focus, .slds-listbox--vertical .slds-listbox__option:hover, .slds-listbox_vertical .slds-listbox__option.slds-has-focus, .slds-listbox_vertical .slds-listbox__option:focus, .slds-listbox_vertical .slds-listbox__option:hover {
      background-color: var(--table-hover, #f3f3f3);
    }
    .slds-input_faux>img {
      margin-top: 0.3rem;
    }
    `
  ];

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOption(option) {
    this.selected = option;
    // Create a custom event with the selected option
    const event = new CustomEvent('option-selected', {
      detail: { value: option },
      bubbles: true,
      composed: true
    });
    // Dispatch the event
    this.dispatchEvent(event);
    this.isOpen = false;
  }

  render() {
    return html`
    <div class="slds-form-element">
      ${this.label ? html`<label class="slds-form-element__label" for="combobox-value-id" id="combobox-label-id">${this.label}</label>` : ''}
      <div class="slds-form-element__control">
        <div class="slds-combobox_container">
          <div class="slds-combobox slds-dropdown-trigger slds-dropdown-trigger_click ${this.isOpen ? 'slds-is-open' : ''}" aria-expanded="${this.isOpen}" aria-haspopup="listbox" role="combobox">
            <div class="slds-combobox__form-element slds-input-has-icon slds-input-has-icon_right" role="none">
              <button type="button" class="slds-input_faux slds-combobox__input" aria-labelledby="combobox-label-id combobox-id-selected-value" id="combobox-id-selected-value" aria-controls="listbox-id-1" aria-expanded="${this.isOpen}" aria-haspopup="listbox" @click="${this.toggleDropdown}">
                ${this.selected && this.selected.icon ? html`
                  <img src="${this.selected.icon}" alt="${this.selected.title}" class="slds-avatar slds-avatar_x-small slds-m-right_x-small" />
                ` : ''}
                <span class="slds-truncate" id="combobox-value-id">${this.selected ? this.selected.title : this.placeholder}</span>
              </button>
              <span class="slds-icon_container slds-icon-utility-down slds-input__icon slds-input__icon_right">
                <svg class="slds-icon slds-icon slds-icon_x-small slds-icon-text-default" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#down"></use>
                </svg>
              </span>
            </div>
            <div id="listbox-id-1" class="slds-dropdown slds-dropdown_length-5 slds-dropdown_fluid" role="listbox">
              <ul class="slds-listbox slds-listbox_vertical" role="presentation">
                ${this.options.map(option => html`
                  <li role="presentation" class="slds-listbox__item">
                    <div id="${option.id}" class="slds-media slds-listbox__option slds-listbox__option_plain slds-media_small ${this.selected && this.selected.id === option.id ? 'slds-is-selected' : ''}" role="option" @click="${() => this.selectOption(option)}">
                      ${!option.icon ? html`
                        <span class="slds-media__figure slds-listbox__option-icon">
                          ${this.selected && this.selected.id === option.id ? html`
                            <span class="slds-icon_container slds-icon-utility-check slds-current-color">
                              <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
                                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#check"></use>
                              </svg>
                            </span>
                          ` : ''}
                        </span>
                      ` : ''}
                      <span class="slds-media__body">
                        ${option.icon ? html`
                          <img src="${option.icon}" alt="${option.title}" class="slds-avatar slds-avatar_x-small slds-m-right_x-small" />
                        ` : ''}
                        <span class="slds-truncate" title="${option.title}">${option.title}</span>
                      </span>
                    </div>
                  </li>
                `)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    `
  }
}
